module.exports = __webpack_public_path__ + "static/media/logo.9d89b8d5.png";